import {Component} from '@angular/core';
import {HeaderService} from '../../header.service';

@Component({
    selector: 'app-breakfast',
    templateUrl: './breakfast.component.html',
    styleUrls: ['./breakfast.component.css']
    })
export class BreakfastComponent {

    constructor(private headerService: HeaderService) {
        this.headerService.setHeaderImage('assets/img/breakfast/breakfast1.jpeg');
        this.headerService.setHeaderTitle('Frühstück');
        this.headerService.setHeaderContext('Der Tag beginnt am besten mit einem ausgewogenen, gesunden Frühstück. Kaffee oder Kakao dürfen dabei natürlich nicht fehlen.');
    }
}
